import { connect } from 'react-redux'
import { withWizard } from 'react-albus'

import { setWizards, resetTradeInWizard } from 'core/components/wizard/actions'

import TradeIn from './TradeIn'

const mapStateToProps = state => ({
  wizards: state.wizards,
  tradeInConfig: state.configuration.campaign.tradeInConfig
})

const mapDispatchToProps = {
  setWizards,
  resetTradeInWizard
}

// For test.js
export const ConnectedTradeIn = connect(mapStateToProps, mapDispatchToProps)(withWizard(TradeIn))

export default withWizard(connect(mapStateToProps, mapDispatchToProps)(TradeIn))
